<template>
  <div class="user-center__collect-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
          >{{ nav.name }}{{nav.num > 0 ? `（${nav.num}）` : ''}}</router-link
        >
      </template>
    </SubPageHeader>
    <div class="collect__main-body">
      <router-view :key="$route.fullpath" @counts="getCounts"></router-view>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../_pageHeader.vue';

export default {
  components: {
    SubPageHeader,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '清单',
          url: '/my/collects/products/0',
          num: 0,
        },
        {
          name: '案例',
          url: '/my/collects/cases',
          num: 0,
        },
        {
          name: '需求',
          url: '/my/collects/requirements',
          num: 0,
        },
      ],
    };
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    init() {
    },
    getCounts(counts) {
      this.breadcrumbs.map((item) => {
        const temp = item;
        temp.num = temp.url === this.$route.path ? counts : temp.num;
        return temp;
      });
    },
  },
};
</script>

<style></style>
